import { useTranslation } from 'react-i18next';

import {
  borderColours,
  type StockStatus,
  textColours
} from '~/domain/stockStatus';
import useRegion from '~/hooks/useRegion';
import {
  formatReleaseDateLarge,
  formatReleaseDateShort,
  getCurrentDateUnix
} from '~/utils/dates';

type Props = {
  releaseDate?: EpochTimeStamp;
  releaseDateFormat?: 'short' | 'long';
  size?: 'LARGE' | 'DEFAULT';
  status?: StockStatus;
};

export default function StockStatusPill({
  status,
  size,
  releaseDate = 0,
  releaseDateFormat = 'short'
}: Props) {
  const { t } = useTranslation();
  const region = useRegion();

  if (!status) return null;

  let textSize;
  let padding;

  switch (size) {
    case 'LARGE':
      textSize = 'text-xs';
      padding = 'py-2 px-4';
      break;
    default:
      textSize = 'text-[10px]';
      padding = 'py-1 px-2';
      break;
  }

  const formattedReleaseDate =
    releaseDateFormat === 'long'
      ? formatReleaseDateLarge(releaseDate, region)
      : formatReleaseDateShort(releaseDate, region);

  return (
    <span
      data-cy="stock-status"
      className={`${textSize} ${padding} rounded-full border bg-white font-semibold ${textColours[status]} ${borderColours[status]}`}
    >
      {['coming-soon', 'tbc', 'upcoming'].includes(status) &&
      releaseDate > getCurrentDateUnix()
        ? formattedReleaseDate
        : t(status)}
    </span>
  );
}
